import axios from "axios";
import { alertFun } from "../components/Modal/index";
import { getToken } from "../utils/auth";
import webConfig from "../config/config";

// create an axios instance
const service = axios.create({
  baseURL: "/",
  method: "get",
  headers: {
    Authorization: "",
    Device: "WEB",
    ModuleId: "",
    "X-Gateway-Version": 3,
    "Content-Type": "application/json",
  },
  params: {},
  responseType: "json",
  timeout: 2 * 60 * 1000,
  withCredentials: true,
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    const token = getToken();
    const language = webConfig.language;
    if (token) {
      config.headers["Authorization"] = token;
    }
    if (language) {
      config.headers["Language"] = language;
    }
    config.headers.Merchant = webConfig.merchant;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;
    if (response.status === 200) {
      return Promise.resolve(res);
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if (error.response.status) {
      switch (error.response.status) {
        case 401:
          break;
        default:
          alertFun(error.response.data.message);
      }
      return Promise.reject(error.response);
    }
  }
);

export default {
  get: (link, params = {}) => {
    let { data, headers } = params;
    return service({
      method: "get",
      url: link.url,
      params: data,
      headers: {
        ModuleId: link.moduleId,
        ...headers,
      },
    });
  },
  post: (link, params = {}) => {
    let { data, headers } = params;
    return service({
      method: "post",
      url: link.url,
      data: data,
      headers: {
        ModuleId: link.moduleId,
        ...headers,
      },
    });
  },
  put: (link, params = {}) => {
    let { data, headers } = params;
    return service({
      method: "put",
      url: link.url,
      data: data,
      headers: {
        ModuleId: link.moduleId,
        ...headers,
      },
    });
  },
  delete: (link, params = {}) => {
    let { data, headers } = params;
    return service({
      method: "delete",
      url: link.url,
      data: data,
      headers: {
        ModuleId: link.moduleId,
        ...headers,
      },
    });
  },
};
